import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = ["value", "placeholder", "pattern", "readonly", "disabled"]

import { computed, ref } from 'vue';
import { debounce } from '@/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInputNumber',
  props: {
    modelValue: null,
    minFractionDigits: null,
    maxFractionDigits: null,
    min: null,
    max: null,
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    inputClass: null,
    inputStyle: null,
    inputProps: null,
    placeholder: null
  },
  emits: ["update:modelValue", "focus", "blur", "input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: string | null): void;
  (e: 'focus'): void;
  (e: 'blur'): void;
  (e: 'input', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  minFractionDigits?: number;
  maxFractionDigits?: number;
  min?: number;
  max?: number;
  readonly?: boolean;
  disabled?: boolean;
  inputClass?: string | Record<string, any>;
  inputStyle?: Record<string, any>;
  inputProps?: null;
  placeholder?: string;
}





const inputRef = ref<HTMLInputElement | null>(null);
const inputValue = computed({
  get: () => props.modelValue,
  set: value => emits('update:modelValue', value),
});
const pattern = computed(() => `^\\d*?(?:\\\\[.])?\\d{0,${props.maxFractionDigits ?? '2'}}$`);
const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const textAlign = computed(() => (props.inputClass?.includes('text-left') ? '' : 'text-right'));
const onInput = debounce(event => {
  const nextUserInput = event.target.value.replace(/,/g, '.');
  if (nextUserInput === '' || RegExp(pattern.value).test(escapeRegExp(nextUserInput))) {
    inputRef.value!.value = nextUserInput;
    inputValue.value = nextUserInput;
    emits('input', nextUserInput);
  } else {
    inputRef.value!.value = inputValue.value;
  }
}, 300);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      value: _unref(inputValue),
      onBlur: _cache[0] || (_cache[0] = ($event: any) => (emits('blur'))),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (emits('focus'))),
      onInput: _cache[2] || (_cache[2] = ($event: any) => (_unref(onInput)($event))),
      placeholder: __props.placeholder ?? '0',
      pattern: `^[0-9]*[.,]?[0-9]{${__props.maxFractionDigits ?? '2'}}$`,
      readonly: __props.readonly,
      disabled: __props.disabled,
      class: _normalizeClass(`input-number w-full ${__props.inputClass} ${_unref(textAlign)}`),
      style: _normalizeStyle(__props.inputStyle)
    }, null, 46, _hoisted_2)
  ]))
}
}

})